var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-section',[_c('app-elements',{attrs:{"categoryGroups":_vm.categoryGroups,"sectionHandle":"post","displayTextSearch":true,"options":{
            limit: 12
        }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }